import { cn } from '@simplywallst/ui-core/next';
import type { ReactNode } from 'react';
import { useState } from 'react';

type Props = {
  enableImages: boolean;
  pristine: boolean;
  onFileDrop: (file: File) => Promise<string | null>;
  children: ReactNode;
  className?: string;
  onClick: () => void;
};

export const EditorDropzone = ({
  enableImages,
  pristine,
  onFileDrop,
  children,
  className,
  onClick,
}: Props) => {
  const [isDraggingFile, setIsDraggingFile] = useState(false);

  return (
    <div
      data-cy-id="rte-wrapper"
      data-testid="rte-wrapper"
      onClick={onClick}
      className={cn('relative', className)}
      onDragOver={(e) => {
        e.preventDefault();
        if (!enableImages) return;
        setIsDraggingFile(
          !!e.dataTransfer.types.some((type) => type === 'Files')
        );
      }}
      onDragLeave={() => setIsDraggingFile(false)}
      onDrop={async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!enableImages || !pristine) return;

        setIsDraggingFile(false);
        onFileDrop(e.dataTransfer.files[0]);
      }}
      onBlur={() => setIsDraggingFile(false)}
    >
      {isDraggingFile && pristine && (
        <div className="absolute inset-0 z-10 grid place-content-center border-4 border-dashed border-accent bg-surface-3 text-mega font-strong text-solid">
          Drop files here
        </div>
      )}
      {children}
    </div>
  );
};
